module.exports = __webpack_public_path__ + "img/65.9ce373ef.jpg";